import React from "react";

function BrandLogo({ compact = false, size = "md" }) {
  const dims = sizeMap[size] || sizeMap.md;
  if (compact) return <span style={{ ...dot, width: dims.dot, height: dims.dot }}>P</span>;
  return (
    <span style={wrap}>
      <span style={{ ...dot, width: dims.dot, height: dims.dot }}>P</span>
      <span style={{ fontSize: dims.fontSize, ...textWrap }}>
        <span style={orange}>POS</span>
        <span style={green}> Matka</span>
      </span>
    </span>
  );
}

export default BrandLogo;

const sizeMap = {
  md: { dot: 38, fontSize: "17px" },
  sm: { dot: 30, fontSize: "13px" },
  xs: { dot: 24, fontSize: "11px" },
};

const wrap = { display: "inline-flex", alignItems: "center", gap: "8px" };
const dot  = {
  display: "grid", placeItems: "center",
  borderRadius: "10px",
  background: "#7c2d12",
  color: "#fb923c",
  fontWeight: 900,
  fontSize: "inherit",
  flexShrink: 0,
};
const textWrap = { fontWeight: 900, fontFamily: "'Arial Black', Impact, sans-serif", lineHeight: 1 };
const orange   = { color: "#f97316" };
const green    = { color: "#16a34a" };
